import { memo } from "react";
import { Checkbox } from "@tecorien/mimic";
import { AvailableFonts } from "../fonts";
import { SignatureCardSelector, SignatureCardSelectorProps } from "../SignatureCardSelector";

import styles from "./styles.module.scss";

export type SignatureCardBlockProps = SignatureCardSelectorProps & {
  checkBoxClassName?: string
}

export const SignatureCardBlock = memo<SignatureCardBlockProps>(({ checkBoxClassName, ...selectorProps }) => {
  return (
    <>
      <Checkbox
        value={!!selectorProps.value}
        label="I agree to use the electronic signature"
        onChange={(e, v) => {
          selectorProps.onChange?.(v ? AvailableFonts.Handsta : null);
        }}
        disabled={selectorProps.disabled}
        errorText={selectorProps.errorText || undefined}
        hasError={selectorProps.hasError}
        className={checkBoxClassName}
      />
      {
        selectorProps.value && <>
          <div className={styles.choose}>Choose signature option</div>
          <SignatureCardSelector {...selectorProps} />
        </>
      }
    </>
  );
});

export default SignatureCardBlock;